<template>
  <div class="popup_in">
    <div class="popup">
      <template v-if="isLoading">
        <div class="spinner"></div>
        <h2 class="title title--40">{{ loadingTitle }}</h2>
      </template>
      <template v-else-if="hasError">
        <img
          style="width:42px;margin-bottom:10px"
          src="/assets/img/svg/alert.svg"
        />
        <h2 class="title title--40">{{ errorTitle }}</h2>
        <div class="flex flex--content--center">
          <a class="bt_blue" @click.prevent="$emit('close')">סגור</a>
        </div>
      </template>
      <template v-else>
        <img
          style="width:42px;margin-bottom:10px"
          src="/assets/img/svg/ok-green.svg"
        />
        <h2 class="title title--40">{{ title }}</h2>
        <div class="flex flex--content--center">
          <a class="bt_blue" @click.prevent="$emit('close')">סגור</a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "הפעולה בוצעה בהצלחה"
    },
    loadingTitle: {
      type: String,
      default: "מבצע פעולה..."
    },
    errorTitle: {
      type: String,
      default: "התרחשה שגיאה אנא רענן את המסך"
    },
    action: {
      type: Promise,
      default: null
    }
  },
  data() {
    return {
      isLoading: !!this.action,
      hasError: false
    };
  },
  async mounted() {
    if (this.action) {
      try {
        await this.action;
        this.isLoading = false;
      } catch {
        this.isLoading = false;
        this.hasError = true;
      }
    }
  }
};
</script>

<style scoped>
.spinner {
  width: 42px;
  height: 42px;
  margin-bottom: 10px;
  border: 4px solid #e0e0e0;
  border-top-color: #324997;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  display: inline-block;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
